import { cB as e, cM as i, c as t } from "./highrise314.mjs";
const r = e("icon", `
 height: 1em;
 width: 1em;
 line-height: 1em;
 text-align: center;
 display: inline-block;
 position: relative;
 fill: currentColor;
`, [i("color-transition", {
  transition: "color .3s var(--n-bezier)"
}), i("depth", {
  color: "var(--n-color)"
}, [t("svg", {
  opacity: "var(--n-opacity)",
  transition: "opacity .3s var(--n-bezier)"
})]), t("svg", {
  height: "1em",
  width: "1em"
})]);
export {
  r as default
};
